<template>
  <div class="container">
    <div class="mainContainer">
      <img class="bacloding" src="../assets/index_loading.gif"/>
      <img class="bacText" src="../assets/index_text.png" />
    </div>
    <img class="preloadImg" v-for="(optImg, index) in optBacImg" :key="index" :src="optBacImg[index]" ref="preloadImg"/>
  </div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {
      optBacImg: [
        require('../assets/gaokao_pre/p1.png'),
        require('../assets/gaokao_pre/p2.png'),
        require('../assets/gaokao_pre/p3.png'),
        require('../assets/gaokao_pre/p4.png'),
        require('../assets/gaokao_pre/p5.png'),
        require('../assets/gaokao_pre/p6.png'),
        require('../assets/gaokao_pre/p7.png'),
        require('../assets/gaokao_pre/p8.png'),
        require('../assets/gaokao_pre/p9.png'),
        require('../assets/gaokao_after/p1.png'),
        require('../assets/gaokao_after/p2.png'),
        require('../assets/gaokao_after/p3.png'),
        require('../assets/gaokao_after/p4.png'),
        require('../assets/gaokao_after/p5.png'),
        require('../assets/gaokao_after/p6.png'),
        require('../assets/gaokao_after/p7.png'),
        require('../assets/gaokao_after/p8.png'),
        require('../assets/gaokao_after/p9.png'),
        require('../assets/inputname_top.png'),
        require('../assets/inputname_bottom.png'),
        require('../assets/pop_up.png'),
        require('../assets/pop_up_blue.png'),
        require('../assets/name_loading.gif'),
      ],
      imgNum: 0
    }
  },
  mounted () {
    this.$store.commit('clearAll');
    let img = this.$refs.preloadImg
    for(let i = 0; i<img.length; i++){
      img[i].onload = () => {
        this.imgNum++
      }
    }
  },
  watch: {
    imgNum (val) {
      if(val === 23) {
        setTimeout(() => {
          this.$router.replace({path:'/second'})
        },2000)
      }
    }
  }
}
</script>
<style scoped>
.container{
  width: 100%;
  height: 100%;
  background: #f3ebe2;
  margin: 0 auto;
}
.mainContainer{
  width: 7.5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-3.75rem, -1.2rem);
}
.mainContainer img{
  display: block;
  margin: 0 auto;
}
.bacloding{
  width: 5rem;
  height: 1.33rem;
}
.bacText{
  width: 2rem;
  height: 0.3rem;
}
.preloadImg{
  display: none;
}
</style>

